export const environment = {
  production: true,
  version: '2.23.1',
  appConfigUrl: 'assets/config/app.config.json',
  dashboardId_En: 'd1820d56-0024-4d30-8ea9-7da0a57c5f7f',
  dashboardId_De: '1e10b0b8-ba37-4f4c-954f-0f5d00800934',
  webKioskUrl: 'https://aims.spaceforce.one/',
  Email: {
    technicalEmail: 'k.grabenstein@wissenswerft.de',
  }
};
